import { Box, Container, Grid, IconButton, useTheme } from "@mui/material";
import { useEffect, useState } from "react";

import BoxTransferHistory from "./Component/BoxTransferHistory";
import { Filter } from "assets/Icon";
import FilterTransferHistory from "./Component/FilterTransferHistory";
import Pagination from "components/Pagination";
import TableTransferHistory from "./Component/TableTransferHistory";
import TableSkeleton from "components/Skeletons/Table.skeleton";
import useIsMobileView from "hooks/useIsMobileView";
import useNotify from "hooks/useNotify";
import { useSearchParams } from "react-router-dom";
import {
  getSpotTransferHistoryForm,
  getSpotTransferHistoryList,
} from "store/slices/wallet/walletSlice";
import useDispatch from "hooks/useDispatch";
import { useSelector } from "react-redux";
import { formatDateToJalali } from "utils/helpers/time";

function TransferHistory() {
  const dispatch = useDispatch();

  const theme = useTheme();
  const notify = useNotify();
  const isMobileView = useIsMobileView();
  const [searchParams] = useSearchParams();

  const [loading, setLoading] = useState(false);
  const [showFilter, setShowFilter] = useState();

  const pageNumber = +searchParams.get("page") || 1;
  const pageSize = +searchParams.get("perPage") || 10;
  const dateFrom = +searchParams.get("dateFrom");
  const dateTo = +searchParams.get("dateTo");
  const transferId = +searchParams.get("transferId") || 0;
  const coinId = +searchParams.get("coinId") || -1;
  
  const historyList = useSelector(
    (state) => state.wallet?.spotTransferHistoryList?.data
  );

  const getHistoryList = async ({ pageNumber, pageSize }) => {
    try {
      setLoading(true);
      const body = {
        coinId: coinId,
        typeTransferId: transferId,
        startDate: formatDateToJalali(dateFrom),
        endDate: formatDateToJalali(dateTo),
        pageNumber: pageNumber,
        pageSize: pageSize,
      };
      await dispatch(getSpotTransferHistoryList(body));

      setLoading(false);
    } catch (e) {
      notify(e?.response?.data?.message, "error");
    }
  };

  const handleChangePaginate = ({ page, perPage }) => {
    getHistoryList({ pageNumber: page, pageSize: perPage });
  };

  useEffect(() => {
    dispatch(getSpotTransferHistoryForm());
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getHistoryList({ pageSize, pageNumber });
    // eslint-disable-next-line
  }, [transferId, coinId, dateFrom, dateTo]);

  return (
    <Container maxWidth="100%">
      <Grid container>
        <Grid item xs={12}>
          <Box display="flex" flexDirection="row-reverse" mb={2}>
            <IconButton
              onClick={() => {
                setShowFilter((v) => !v);
              }}
              aria-label="filter"
            >
              <Filter color={theme.palette.text.main} />
            </IconButton>
          </Box>

          {showFilter && (
              <FilterTransferHistory />
          )}
        </Grid>

        <Grid item xs={12}>
          {isMobileView ? (
            <>
              {historyList?.data?.map((transferHistoryItem) => (
                <BoxTransferHistory transferHistoryItem={transferHistoryItem} />
              ))}
            </>
          ) : (
            <>
              {!loading ? (
                <TableTransferHistory historyList={historyList} />
              ) : (
                <TableSkeleton />
              )}
            </>
          )}
        </Grid>

        <Grid item xs={12}>
          <Pagination
            count={historyList?.totalPages}
            perPage={historyList?.pageSize}
            onChange={handleChangePaginate}
          />
        </Grid>
      </Grid>
    </Container>
  );
}

export default TransferHistory;
